<template>
  <div class="content-tab mac-address-content">
    <div class="content-body">
      <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
      <div class="describe" ref="describe">
        {{$t('mactable.describe')}}
      </div>
      <div class="content-item">
        <div class="form">
          <div class="formRow dt">
            <div class="dt-r">
              <div class="title dt-c">{{$t('mactable.dynamicTime')}}</div>
              <div class="forminput dt-c">
                <div :title="macTime" class="macTimeInput" v-if="macTime && !isEdit">{{macTime}}</div>
                <div v-else>
                  <input ref="agingTime" name="ID" class="form-control macTimeInput" type="text" v-model="macTime" v-validate="'required|numeric|max_value:400|min_value:10'" :class="{'error': errors.has('ID') }" @keyup="onBlur" @keypress="onlyNumber" min="10" max="400">
                </div>
                <span class="range"> ({{$t('mactable.secRange', 400)}})</span>
                <span class="icon-edit" @click="onAgingTimeAction('edit')" v-if="!isEdit" :title="$t('edit')"/>
                <span class="icon-tick" @click="onAgingTimeAction('save')" v-else :disabled="errors.has('ID')" :title="$t('save')"/>
                <span class="icon-btn_close" @click="onAgingTimeAction('cancel')" v-if="isEdit" :title="$t('cancel')"/>
              </div>
            </div>
            <div class="dt-r">
              <div class="dt-c"></div>
              <div v-show="errors.has('ID')" class="errorMessage dt-c">{{setErrorMessage(errors.first('ID'))}}</div>
            </div>
          </div>
          <div class="formRow">
            <div class="search-header title">{{$t('mactable.search')}}</div>
            <q-select class="q-select" :value="filterType" :options-array="menuOptions" @change="onMenuChange"></q-select>
            <div class="forminput search icon-search">
              <input name="filterDetail" type="text" class="form-control filterInput" :placeholder="$t('search')" @change="onSearchClick" @keyup.enter="onSearchClick" v-model="filterDetail">
            </div>
            <button class="q-button blue-btn-full footer-btn right" @click="onActionClick('add')" :title="$t('add')">{{$t('add')}}</button>
          </div>
        </div>
      </div>
      <div class="group-table" ref="groupTable">
        <fixed-table class="mac-address-table" :data="addressList" :use-page="false" :header-height="40" :right-fills="0">
          <div class=left-header slot="left-header">
            <div class="inner"></div>
          </div>
          <div class="right-header" slot="right-header">
            <column style="width: 8%;"></column>
            <column style="text-align:left; padding: 0 16px; bottom: 10px; " :style="{ width:'48%'}">{{ $t('overview.portNo') }}</column>
            <column style="width: 10%; text-align:left; padding: 0 16px; bottom: 10px">{{ $t('lag.groupName') }}</column>
            <column style="width: 34%;"></column>
          </div>
          <div class="right-header" slot="right-header">
            <column :title="this.$isOverflow($t('vlan.vlanId'))" :id="$t('vlan.vlanId')" style="width: 8%; bottom: 20px" sort="key" :number="true">{{$t('vlan.vlanId')}}</column>
            <column v-for="num in portNumber" :key="num" :style="{ width: 48/portNumber + '%' }" style="bottom: 10px">{{num}}</column>
            <column class="portNo" v-for="num in lagGroupMap.size" :key="num+lagStartNum" style="bottom: 10px" :style="{ width: 24/lagGroupMap.size + '%' }">{{num}}</column>
            <column :title="this.$isOverflow($t('port.mac'))" :id="$t('port.mac')" style="width: 10%; bottom: 20px;" sort="macAddress">{{$t('port.mac')}}</column>
            <column :title="this.$isOverflow($t('mactable.type'))" :id="$t('mactable.type')" style="width: 10%; bottom: 20px;" sort="Dynamic" :number="true">{{$t('mactable.type')}}</column>
          </div>
          <div class="content-item empty" slot="empty">
            <nodata v-if="filterDetail===''" />
            <noresult v-else/>
            <div class="message">{{(filterDetail==='') ? $t('empty') : $t('noResult')}}</div>
          </div>
          <template slot="rows" slot-scope="props">
              <div class="link-row" v-if="checkData(props.data)">
                  <row class="right" :props="props">
                      <div :title="props.data.key[0]" class="data" style="width: 8%;">{{props.data.key[0]}}</div>
                      <div class="data portNo" :style="{ width: 48/portNumber + '%' }" v-for="index in portNumber" :key="index">
                        <span v-if="getPortMembers(props.data.val.Port, index)" class="q-icon icon-tick"></span>
                      </div>
                      <div class="data portNo" :style="{ width: 24/lagGroupMap.size + '%' }" v-for="index in lagGroupMap.size" :key="index+lagStartNum">
                        <span v-if="getPortMembers(props.data.val.Port, index + lagStartNum)" class="q-icon icon-tick"></span>
                      </div>
                      <div :title="props.data.key[1]" class="data" style="width: 10%;">{{props.data.key[1]}}</div>
                      <div :title="getType(props.data.val.Dynamic)" class="data" style="width: 10%;" :class="{ static: getStaticItem(props.data.val)}">
                        {{getType(props.data.val.Dynamic)}}
                        <span class="icon-edit" :title="$t('edit')" v-if="getStaticItem(props.data.val)" @click="onActionClick('edit', props.data)"/>
                        <span class="icon-trashcan" :title="$t('delete')" v-if="getStaticItem(props.data.val)" @click="onDeleteClick(props.data)"/>
                      </div>
                  </row>
              </div>
          </template>
        </fixed-table>
      </div>
    </div>
    <StaticMac :modalTitle=modalTitle :selectObj="selectObj" :onChange="getAddressList"></StaticMac>
    <popup-confirm name="mac-modal" :dialog-header="$t('mactable.deleteTitle')" :dialog-message="$t('mactable.deleteContent')" icon="w" type="d" :callback="goDelete" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import StaticMac from './StaticMac'
import qSelect from './module/Select.vue'
import nodata from '../assets/svg/no_data.svg'
import noresult from '../assets/svg/no_result.svg'
export default {
  name: 'MacAddressTable',
  components: {
    fixedTable,
    row,
    column,
    StaticMac,
    qSelect,
    nodata,
    noresult
  },
  data () {
    return {
      macTime: 10,
      originalMacTime: 0,
      addressList: [],
      tempList: [],
      filterList: [],
      modalTitle: '',
      filterDetail: '',
      filterType: 'vlanId',
      isSearch: false,
      macTimeId: null,
      deleteGroupObj: null,
      isEdit: false,
      isEmpty: false,
      isShowLoading: false,
      isValidate: true,
      isTableResize: false,
      menuOptions: [
        { value: 'vlanId', label: 'vlan.vlanId' },
        { value: 'macAddress', label: 'port.mac' },
        { value: 'type', label: 'mactable.type' },
        { value: 'port', label: 'overview.portNo' }
      ],
      selectObj: {},
      dataInterval: null
    }
  },
  created: async function () {
    this.isShowLoading = true
    this.getDynamicTime()
    this.getAddressList()
  },
  mounted () {
    this.onResize(this.showQuickHelp)
  },
  beforeDestroy () {
    clearInterval(this.dataInterval)
    this.dataInterval = null
  },
  watch: {
    showQuickHelp (value) {
      setTimeout(() => {
        this.onResize(value)
      }, 400)
    },
    currentUser: {
      handler (value) {
        if (!value) {
          this.$store.commit('updateGetDeviceData', false)
          clearInterval(this.dataInterval)
          this.dataInterval = null
          this.onClose()
        }
      },
      immediate: true,
      deep: true
    },
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.dataInterval)
        this.dataInterval = null
      }
    }
  },
  methods: {
    ...mapActions(['getMacTime', 'getMacList', 'setMacTime', 'delStaticMac']),
    onResize: function (status) {
      var describeHeight = this.$refs.describe.offsetHeight - 20
      var tableHeight = this.$refs.groupTable.offsetHeight
      if (status) {
        this.$refs.groupTable.style.height = tableHeight - describeHeight + 'px'
      } else {
        this.$refs.groupTable.style.height = 'calc(100% - 100px)'
      }
    },
    getPortMembers: function (members, number) {
      return (members === '' + number)
    },
    getDynamicTime: function () {
      this.getMacTime()
        .then(res => {
          if (res.status === 200) {
            let detail = (res.data)
            this.macTime = detail.result.AgeTime
            this.originalMacTime = JSON.parse(JSON.stringify(this.macTime))
          }
        })
        .catch(error => {
          this.$log.error(error)
        })
    },
    getAddressList: function () {
      this.isShowLoading = true
      this.getMacList()
        .then(res => {
          if (res.status === 200) {
            let detail = (res.data)
            this.addressList = detail.result
            this.tempList = this.addressList
            this.isShowLoading = false
            this.getDataInterval()
          }
        })
        .catch(error => {
          this.$log.error(error)
        })
    },
    getType: function (type) {
      if (type) {
        return this.$t('mactable.dynamic')
      } else {
        return this.$t('mactable.static')
      }
    },
    getDataInterval: function () {
      let me = this
      if (!this.dataInterval) {
        this.dataInterval = setInterval(() => {
          if (this.showFullLoading) {
            clearInterval(this.dataInterval)
            this.dataInterval = null
          } else {
            this.getMacList()
              .then(res => {
                if (res.status === 200) {
                  let detail = (res.data)
                  if (!me.filterDetail) {
                    me.addressList = detail.result
                  } else {
                    me.tempList = detail.result
                    this.onSearchClick()
                  }
                }
              })
              .catch(error => {
                this.$log.error(error)
              })
          }
        }, this.intervalTime)
      }
    },
    checkMAC: function (key, data) {
      let result = null
      let tempKey = key.toLowerCase()
      let tempData = data.toLowerCase()
      if (tempKey.includes(tempData)) {
        result = true
      } else {
        result = false
      }
      return result
    },
    checkDynamic: function (data) {
      let result = null
      let str = ['static', 'dynamic']
      let tempData = data.toLowerCase()
      if (str[1].includes(tempData)) {
        result = true
      } else if (str[0].includes(tempData)) {
        result = false
      }
      return result
    },
    checkLogicalPort: function (key, data) {
      let tempData = data.toLowerCase()
      let result = false
      for (let idx = 1; idx < this.lagStartNum; idx++) {
        let str = ['lag' + idx, 'lag ' + idx]
        if (str[0].includes(tempData) || str[1].includes(tempData)) {
          if (key === this.lagStartNum + idx) {
            result = true
          }
        }
      }
      return result
    },
    getStaticItem: function (data) {
      if (!data.Dynamic) {
        if (!data.CopyToCpu) {
          return true
        } else {
          return false
        }
      }
    },
    onDeleteClick: function (data) {
      this.$modal.show('mac-modal')
      this.deleteGroupObj = data
    },
    goDelete: function () {
      this.isShowLoading = true
      this.$log.info('go delete')
      this.$modal.hide('mac-modal')
      this.delStaticMac([this.deleteGroupObj.key[0], this.deleteGroupObj.key[1]]).then((res) => {
        this.getDynamicTime()
        this.getAddressList()
      })
        .catch(error => {
          this.$log.error(error)
        })
    },
    onActionClick: function (type, data) {
      this.selectObj = {}
      if (type === 'add') {
        this.selectObj = Object.assign({}, this.selectObject, null)
        this.modalTitle = this.$t('mactable.addAddress')
        this.$modal.show('add-address-modal')
      } else if (type === 'edit') {
        this.selectObj = Object.assign({}, this.selectObject, data)
        this.modalTitle = this.$t('mactable.editAddress')
        this.$modal.show('add-address-modal')
      }
    },
    onSearchClick: function () {
      let me = this
      let selList = []
      this.filterList = this.tempList
      if (!me.filterDetail) {
        this.addressList = this.tempList
      } else {
        for (const index in this.filterList) {
          if (this.filterList.hasOwnProperty(index)) {
            const element = this.filterList[index]
            if (me.filterType === 'vlanId') {
              if (element.key[0] === me.filterDetail) {
                selList.push(element)
              }
            } else if (me.filterType === 'macAddress') {
              if (me.checkMAC(element.key[1], me.filterDetail)) {
                selList.push(element)
              }
            } else if (me.filterType === 'type') {
              if (element.val.Dynamic === me.checkDynamic(me.filterDetail)) {
                selList.push(element)
              }
            } else {
              let port = Number(me.filterDetail.toLowerCase())
              if (port <= this.portNumber) {
                if (Number(element.val.Port) === port || Number(element.val.Port) === port + me.lagStartNum) {
                  selList.push(element)
                }
              } else if (isNaN(port) && me.checkLogicalPort(Number(element.val.Port), me.filterDetail)) {
                selList.push(element)
              }
            }
          }
        }
        this.addressList = selList
      }
      if (this.addressList.length > 0) {
        me.isEmpty = false
      } else {
        me.isEmpty = true
      }
    },
    onMenuChange: function (value) {
      this.filterType = value
    },
    initGoStatus: function () {
      this.isSearch = false
    },
    onAgingTimeAction: function (type) {
      if (type === 'edit') {
        this.isEdit = true
        setTimeout(() => {
          this.$refs.agingTime.focus()
        }, 100)
      } else if (type === 'cancel') {
        this.macTime = this.originalMacTime
        this.isEdit = false
      } else if (type === 'save') {
        if (this.isValidate) {
          this.setTime()
          if (this.isTableResize) {
            this.$refs.groupTable.style.height = this.$refs.groupTable.offsetHeight + 20 + 'px'
            this.isTableResize = false
          }
        }
      }
    },
    onBlur: function (event) {
      this.checkValidation(event.target.name)
    },
    checkValidation: function (fieldName) {
      this.$validator.validate(fieldName).then((result) => {
        this.isValidate = result
      })
    },
    setTime: function () {
      let me = this
      me.setMacTime({'AgeTime': parseInt(me.macTime)})
        .then(res => {
          if (res.status === 200) {
            me.isEdit = false
            me.getDynamicTime()
          }
        })
        .catch(error => {
          this.$log.error(error)
        })
    },
    checkData: function (item) {
      let value = true
      if (item.key[1].startsWith('33') || item.key[1].startsWith('FF')) {
        value = false
      }
      return value
    },
    setErrorMessage: function (data) {
      let message = ''
      if (data) {
        if (data.indexOf('required') > -1) {
          message = this.$t('errorMessage.isReguired')
        } else {
          message = this.$t('errorMessage.macTimeRange', 400)
        }
        if (!this.isTableResize) {
          this.$refs.groupTable.style.height = this.$refs.groupTable.offsetHeight - 20 + 'px'
          this.isTableResize = true
        }
      }
      return message
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      let isFunctionKey = false
      switch (keyCode) {
        case 8:
          isFunctionKey = true
          break
      }
      if ((keyCode < 48 || keyCode > 57) && !isFunctionKey) { // 46 is dot
        $event.preventDefault()
      }
    },
    getLagTitle (num) {
      let lag = this.lagGroupMap.get(Number(num))
      if (lag.length > 0) return 'Port: ' + lag
    }
  },
  computed: {
    ...mapState({
      portNumber: state => state.module.portNum,
      showQuickHelp: state => state.app.showQuickHelp,
      lagGroupMap: state => state.module.lagGroupMap,
      portMap: state => state.module.portMap,
      currentUser: state => state.module.currentUser,
      lagStartNum: state => state.module.lagStartNum,
      showFullLoading: state => state.module.showFullLoading,
      intervalTime: state => state.app.intervalTime
    })
  }
}
</script>

<style lang="scss" scoped deep>
.mac-address-content{
  position: relative;
  .content-body {
    padding: 10px;
    .formRow {
      padding-top: 10px;
      div {
        display: inline-block;
      }
      .macTimeInput {
        width: 100px !important;
      }
      .range {
        margin: 0px 5px;
        color: #6370AF;
      }
      .search {
        margin-left: 0px;
      }
      .right {
        float: right;
      }
      .icon-tick, .icon-btn_close {
        cursor: pointer;
        width: 30px;
        height: 30px;
        background: #197EC7;
        color: #ffffff;
        border-radius: 50%;
        padding: 2px;
        &:hover {
          background: #1E93E6;
        }
        &:active {
          background: #105180;
        }
        &:focus {
          background: #105180;
        }
        &[disabled=disabled], &.disabled {
          pointer-events: none;
          background: rgba(169,169,169,0.30);
        }
      }
    }
    .group-table {
      padding-top: 10px;
      height: calc(100% - 100px);
      .qweb-column.portNo {
        padding: 0px;
        text-align: center;
      }
      .qweb-column, .data {
        text-overflow: ellipsis;
        /* Required for text-overflow to do anything */
        white-space: nowrap;
        overflow: hidden;
      }
      .link-row {
        >.right {
          >.data {
            user-select: text;
            position: relative;
            .q-icon {
              width: 20px;
              fill: #000000;
              position: absolute;
              top: 9px;
              left: calc(50% - 10px);
            }
            &.portNo {
              padding: 0px;
            }
          }
        }
      }
      .empty {
        text-align: center;
        svg {
          width: 150px;
          height: 150px;
        }
        >div {
          margin: auto;
          font-family: 'Roboto-M' !important;
          font-size: 16px;
        }
      }
    }
    .content-item.empty {
      height: calc(100% - 122px);
      margin-top: 40px;
      margin-bottom: 0px;
      .form {
        margin: auto;
        width: 211px;
        height: 157px;
        background-image: url("../assets/common/no_result.svg");
      }
      .message {
        font-size: 14px;
        text-align: center;
      }
    }
    .mac-address-table {
      position: relative;
      width: 100%;
      overflow: auto;
      /deep/ .header {
        display: inline-block;
        width: 100%;
        min-width: 1250px;
        overflow: hidden;
        position: absolute;
        .right-header {
          flex: none;
          height: 20px;
        }
      }
      /deep/ .body {
        position: absolute;
        width: 100%;
        top: 40px;
        .scrollContainer {
          min-width: 1250px;
        }
      }
    }
  }
  .autosave {
    margin-left: 10px !important;
  }
  .autosave-img {
    font-size: 20px;
    vertical-align: middle;
    color: #7ED321;
    &.error {
      color: #D0021B;
    }
  }
  .autosave-loading {
    background-color: inherit;
    width: inherit;
    height: inherit;
    position: relative;
    top: -6px;
  }
  .forminput.search .filterInput {
    width: auto;
    max-width: 170px;
    min-width: 150px;
  }
  .q-select .display-label {
    font-size: 13px;
    color: #000;
  }
  .q-select {
    margin: 0px 10px !important;
    width: 150px;
    height: 30px;
    border: 1px solid #979797 !important;
    border-radius: 4px;
    vertical-align: middle;
    /deep/ .dropdown-menu {
      left: -1px;
      width: 200px;
      height: auto;
      overflow: auto;
    }
    /deep/ .display-label {
      font-size: 13px !important;
      color: #2F2F2F !important;
      line-height: 30px !important;
    }
    &::after {
      background-color: #000;
      top: -25px;
    }
  }
}
.inner {
  border-bottom: 1px solid #C8C8C8;
  margin:0 0 0 8%;
  width: 71.5%;
  top: 19px;
  position:relative;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/MacAddressTable.vue